<template>
  <rich-button @click="commands.heading({ level: 2 })" v-bind:isActive="isActive.heading({ level: 2 })()" v-bind:icon="'h2'" />
</template>

<script>
  import H2Button from './H2Button.ts'
  export default H2Button
</script>
